// src/components/UserManagement.js
import React, { useState, Suspense } from 'react';
import { Box, Tabs, Tab, Typography, CircularProgress, Paper } from '@mui/material';
import SurveyList from '../Components/Lists/SurveyList';
import EducationLoader from '../Components/Loaders/EducationLoader';

// Lazy-loaded components
const ProgramList = React.lazy(() => import("../Components/Lists/ProgramList"));
const MaterialList = React.lazy(() => import("../Components/Lists/MaterialList"));
const AssessmentList = React.lazy(() => import("../Components/Lists/AssessmentList"));
const SubjectList = React.lazy(() => import("../Components/Lists/SubjectList"));


// Helper component for tab panel content (remains the same)
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`user-tabpanel-${index}`}
      aria-labelledby={`user-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `user-tab-${index}`,
    'aria-controls': `user-tabpanel-${index}`,
  };
}

const CurriculumManagement = () => {
  // Local state for the active tab, always defaults to 0 (Admins)
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Paper elevation={3} sx={{ width: '100%', mb: 2 }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="user type tabs" variant="scrollable" scrollButtons="auto">
          <Tab label="Assessments" {...a11yProps(0)} />
          <Tab label="Materials" {...a11yProps(1)} />
          <Tab label="Programs" {...a11yProps(2)} />
          <Tab label="Subjects" {...a11yProps(3)} />
          <Tab label="Surveys" {...a11yProps(4)} />
        </Tabs>
      </Box>

      {/* Suspense fallback for lazy loading */}
      <Suspense
        fallback={
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '200px',
            }}
          >
            <EducationLoader />
          </Box>
        }
      >
        <TabPanel value={value} index={0}>
          <AssessmentList />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <MaterialList />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <ProgramList />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <SubjectList />
        </TabPanel>
        <TabPanel value={value} index={4}>
          <SurveyList />
        </TabPanel>
      </Suspense>
    </Paper>
  );
};

export default CurriculumManagement;